import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconColors, IconSizes, IrisIconComponent } from '@sondermind/iris/icon';

import { CoverageBadgeType } from './coverage-badge-types';
import { CoverageBadgeStore } from './coverage-badge.store';

@Component({
  selector: 'coverage-badge',
  imports: [CommonModule, IrisIconComponent, RouterModule],
  templateUrl: './coverage-badge.component.html',
  styleUrl: './coverage-badge.component.scss'
})
export class CoverageBadgeComponent {
  readonly providerId = input.required<number>();

  readonly badgeType = computed(() => this.coverageBadgeStore.getCoverageInfo(this.providerId())?.badgeType);
  readonly isUpdating = computed(() => this.coverageBadgeStore.isUpdating(this.providerId()));

  iconColors = IconColors;
  iconSizes = IconSizes;
  coverageBadgeType = CoverageBadgeType;

  constructor(
    private coverageBadgeStore: CoverageBadgeStore
  ) {}

  readonly hasImage = computed(() => ![
    CoverageBadgeType.OUT_OF_NETWORK,
    CoverageBadgeType.SELF_PAY
  ].includes(this.badgeType() || CoverageBadgeType.NONE));

  readonly badgeText = computed(() => {
    switch (this.badgeType()) {
      case CoverageBadgeType.IN_NETWORK:
        return 'In-network';
      case CoverageBadgeType.OUT_OF_NETWORK:
        return 'Out-of-network';
      case CoverageBadgeType.SELF_PAY:
        return 'Takes self-pay';
      case CoverageBadgeType.COVERAGE_NOT_STARTED:
        return 'Insurance not started';
      case CoverageBadgeType.COVERAGE_ENDED:
        return 'Insurance ended';
      case CoverageBadgeType.COVERAGE_UNVERIFIED:
        return 'Unable to verify';
      default:
        return '';
    }
  });

  readonly isClickable = computed(() => [
    CoverageBadgeType.COVERAGE_NOT_STARTED,
    CoverageBadgeType.COVERAGE_ENDED,
    CoverageBadgeType.COVERAGE_UNVERIFIED,
  ].includes(this.badgeType() as CoverageBadgeType));
}
